import { useEffect, useState } from "react";

/*
 * True only when the Afterpay app injected window.apAppNativeExperienceEnabled = true
 * into the gift card checkout webview (gated by the app's gift-card-native-experience
 * flag). Resolved in an effect so SSR and hydration always render the fallback first.
 */
export const useNativeExperience = (): boolean => {
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        setIsEnabled(window.apAppNativeExperienceEnabled === true);
    }, []);

    return isEnabled;
};
